import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import { bindActionCreators } from "redux";
import { filterDomainsForComponent } from "../../utils";
import "./MultiSelectStyles.css";
import { Actions } from "../../Action/index";
import { useLocation } from "react-router-dom";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { Empty } from "antd";
// import { color } from "html2canvas/dist/types/css/types/color";

const customStyles = {
  control: (base) => ({
    ...base,
    height: 29,
    minHeight: 29,
    marginBottom: 5,
    color:'#5c647a',
    borderColor: "lightgray",
    boxShadow: "none",
    "&:hover": {
      borderColor: "lightgray", 
    },
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  clearIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isFocused
      ? "#f6f7f8"
      : state.isSelected?'#f6f7f8':"none",
    color: state.isFocused ||state.isSelected ? "#5c647a" : "#5C667B",
    // fontSize: "14px",
  }),
  menuPortal:(baseStyles,state) => ({
    ...baseStyles,
    zIndex:20000,
    fontSize:'12px',
  })
};

const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  if (Array.isArray(values)) {
    const plural = values.length === 1 ? "" : "s";
    values = `${values.length} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

export default function MultiSelect({ value, onChangeFunc, isMulti, listOptions, disabled,placeholder }) {
  const userData = useSelector((state) => state.user);
  let [option, setOptions] = useState(
    filterDomainsForComponent(userData.expertTopics)
  );
  const onChangeSelectedOption = (value) => {
    onChangeFunc(value);
  };

  const currentPath = useLocation();
  useEffect(()=>{
    if(currentPath.pathname.includes(`${Home_PAGE_URL}keyterm`)){
      let obj = [{
        "id": 25,
        "indexId": 25,
        "name": "All",
        "visible": true,
        "answerable": true,
        "value": "All",
        "label": "All"
    }];
      let newOptions = obj.concat(option);
      setOptions(newOptions);
    }
  }, []);

  const formatGroupLabel = (data) => {
    return(
    <div
      style={{
        fontWeight: "bold",
        fontSize: "12px",
        textTransform:'capitalize'
      }}
    >
      { data.label }
    </div>
    )
    };

    const customNoOptionsMessage = () => <Empty 
   description={<span style={{ color: '#5c667b', fontSize: '12px',fontFamily:'Inter' }}>No Experts Available</span>}
   imageStyle={{ height: 40 }}
   />
// console.log("list",option)

  return (
    <>
      <Select
        className={"multiselect1"}
        onChange={onChangeSelectedOption}
        placeholder={
          listOptions && listOptions.length === 0
            ? "No Experts Available"
            : placeholder !== undefined
            ? placeholder
            : isMulti ? "Select Domains" : "Select Domain"
        }
        options={listOptions !== undefined ? listOptions : option}
        isMulti={isMulti}
        value={value}
        components={{ ValueContainer }}
        closeMenuOnSelect={!isMulti}
        styles={customStyles}
        hideSelectedOptions={false}
        menuPortalTarget={document.body}
        formatGroupLabel={formatGroupLabel}
        isDisabled={disabled}
        noOptionsMessage={customNoOptionsMessage}
      />
    </>
  );
}
